import { createContext } from "react";
const RadioContext = createContext({
  name: "",
  isDisabled: false,
  isReadOnly: false,
  selectedValue: "",
  lastFocusedValue: "",
  setSelectedValue: () => {
  },
  setLastFocusedValue: () => {
  },
  validationState: "valid"
});
export {
  RadioContext
};
//# sourceMappingURL=RadioContext.js.map
